import { useEffect } from "react";
import { useReveal } from "../hooks/useReveal";
import { useHeadTags } from "../hooks/useHeadTags";
import { ApplyProvider } from "../context/ApplyContext";
import { captureAttribution } from "../lib/attribution";
import { Nav } from "../components/landing/Nav";
import { Hero } from "../components/landing/Hero";
import { Problem } from "../components/landing/Problem";
import { Differentiator } from "../components/landing/Differentiator";
import { Deliverables } from "../components/landing/Deliverables";
import { SocialProof } from "../components/landing/SocialProof";
import { Credentials } from "../components/landing/Credentials";
import { Contrast } from "../components/landing/Contrast";
import { Process } from "../components/landing/Process";
import { FinalCTA, TeamTraining } from "../components/landing/FinalCTA";
import { Footer } from "../components/landing/Footer";
import { ApplyModal } from "../components/landing/ApplyModal";
import { LangToast } from "../components/landing/LangToast";

const Landing = () => {
  useReveal();
  useHeadTags();

  useEffect(() => {
    document.body.classList.add("sp-body");
    captureAttribution();
    return () => document.body.classList.remove("sp-body");
  }, []);

  return (
    <ApplyProvider>
      <div data-testid="landing-page">
        <Nav />
        <main>
          <Hero />
          <Problem />
          <Differentiator />
          <Deliverables />
          <SocialProof />
          <Credentials />
          <Contrast />
          <Process />
          <FinalCTA />
          <TeamTraining />
        </main>
        <Footer />
        <ApplyModal />
        <LangToast />
      </div>
    </ApplyProvider>
  );
};

export default Landing;
